module.exports = __webpack_public_path__ + "img/farming_38.282f29af.png";